import isApiError from "@insite/client-framework/Common/isApiError";
import { get } from "@insite/client-framework/Services/ApiService";

export interface OsnAccountDetailsModel {
    customerName: string;
    customerNumber: string;
    id: string;
    address1?: string;
    address2?: string;
    address3?: string;
}
interface AccountNotFoundResponse {
    isSucess: false;
    message: string;
}

interface AccountFoundResponse extends OsnAccountDetailsModel {
    isSucess: true;
}

type GetCustomerApiResponse = AccountFoundResponse | AccountNotFoundResponse;

const url = "/api/v1/accountDetails/getCustomer";

export async function getAccountDetailsService(searchText: string) {
    try {
        const result = await get<GetCustomerApiResponse>(`${url}?searchText=${searchText}`);

        if ("isSucess" in result && result.isSucess === false) {
            return {
                successful: false,
                errorMessage: result.message || "Customer does not exist!",
            };
        }
        return {
            successful: true,
            result: result as OsnAccountDetailsModel,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson?.message || "Customer does not exist!",
            };
        }
        throw error;
    }
}
